import React from "react";
import Image from "components/image";
import { Swiper, SwiperSlide } from "components/swiper";
import { ReactComponent as RightArrow } from "assets/svgs/right-arrow.svg";
import { ReactComponent as LeftArrow } from "assets/svgs/left-arrow.svg";
import { formatTitle } from "helpers/format-title";

const settings = {
	mousewheel: {
		enabled: true,
		forceToAxis: true,
	},
	spaceBetween: 15,
	breakpoints: {
		320: {
			slidesPerView: 3,
			slidesPerGroup: 3,
		},
		768: {
			slidesPerView: 5,
			slidesPerGroup: 5,
			navigation: { navigation: false },
		},
	},
	navigation: {
		enabled: true,
		nextEl: ".right-arrow-ll",
		prevEl: ".left-arrow-ll",
	},
	a11y: false,
};

const LogoList = ({ data }) => {
	return data.slider ? (
		<section className="w-full lg:w-4/5 m-auto relative py-6">
			{data?.title &&
			<h3 className="text-center py-5 mb-8">{formatTitle(data?.title)}</h3>}
			<div className="flex w-3/4 m-auto">
				<Swiper {...settings}>
					{data.image.map((i) => (
						<SwiperSlide key={i._key} className="flex items-center">
							<Image width={100} key={i._key} image={i.asset} alt={i.asset.alt} />
						</SwiperSlide>
					))}
				</Swiper>
			</div>
			<div className="left-arrow-ll">
				<LeftArrow />
			</div>
			<div className="right-arrow-ll">
				<RightArrow />
			</div>
		</section>
	) : (
		<section className="w-full lg:4/5 my-10 px-4">
			{data?.title &&
			<h3 className="text-center py-5 mb-16 ">{formatTitle(data.title)}</h3>}
			<div className="flex flex-row flex-wrap gap-5 md:gap-0 justify-around items-center">
				{data.image.map((i) => (
					<Image className=" brightness-60" width={100} key={i._key} image={i.asset} alt={i.asset.alt} />
				))}
			</div>
		</section>
	);
};

export default LogoList;
